import { useQuery } from "@tanstack/react-query";
import { getDealerSiteDailyStatSummary } from "../api";

export const useGetDealerSiteDailyStatSummary = ({ days = 30 } = {}) => {
  return useQuery({
    queryKey: ["dealer-site-daily-stat-summary", days],
    queryFn: () => getDealerSiteDailyStatSummary({ days }),
  });
};
